export const permissionConstants = {
  PERMISSION_FETCH_REQUEST: "PERMISSION_FETCH_REQUEST",
  PERMISSION_FETCH_SUCCESS: "PERMISSION_FETCH_SUCCESS",
  PERMISSION_FETCH_FAILURE: "PERMISSION_FETCH_FAILURE"
};
